<template>
    <div id="control-consulta-component">
        <main id="mainContent" v-if="!modificar">
            <div class="view">
                <div class="row">
                    <div class="col-12 col-sm-12">
                        <membresias :kind_user="kind_user" :rel_specialist_specialties="rel_specialist_specialties"
                            :rel_specialist_services="rel_specialist_services" @memberStatus="userStatusUpdate">
                        </membresias>
                    </div>
                </div>
            </div>
        </main>
        <form class="formSinester" v-if="Object.keys(user_status).length > 0">
            <div id="sinisterForm">
                <div class="row justify-content-center">
                    <div class="col-12 col-sm-4 flex-align-vertical">
                        <img width="80%" class="img-fluid" src="/images/logo-red-medical.svg" alt="Logo" />
                    </div>
                    <div class="col-12 col-sm-4 offset-sm-4" v-if="role_id === 1">
                        <h4 style="font-size:14px; text-align: right;">Marcar como Pagada</h4>
                        <div style="margin:0 0 0 auto; width:70px;">
                            <input type="checkbox" v-model="sinester.paid_at" hidden="hidden" id="paid_at">
                            <label class="switch" for="paid_at"></label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12">
                        <div class="info_cliente">
                            <ul class="row">
                                <li class="col-12 col-sm-3">
                                    <date-picker inputName="fecha_atencion" input-class="mx-input scr-input required"
                                        v-model="sinester.fecha_atencion" format="YYYY-MM-dd"
                                        placeholder="Fecha de atención" lang="es"></date-picker>
                                </li>
                                <li class="col-12 col-sm-3">
                                    <strong>Paquete:</strong><br /> {{ user_status.paquete }}
                                </li>
                                <li class="col-12 col-sm-3">
                                    <strong>Plan:</strong><br /> <span class="redText">{{ user_status.plan }}</span>
                                </li>
                                <li class="col-12 col-sm-3" v-if="modificar">
                                    <strong>Tipo Servicio:</strong>
                                    <select name="user_status" v-model="sinester.type_service" id="">
                                        <option :value="0">Selecciona un Tipo de Servicio</option>
                                        <option v-for="(type, index) in type_serv_array" :key="type.id" :value="type.id">
                                            {{ type.serv }}
                                        </option>
                                    </select>
                                </li>
                                <li class="col-12 col-sm-3" v-if="!modificar && this.user_status.limit_eventos > 0">
                                    <strong>Total de consultas: </strong> <br>
                                    {{ this.user_status.previous_services_count }}
                                </li>
                            </ul>
                            <ul class="top_info mt-3 row">
                                <li class="col-12 col-sm-4">
                                    <div class="contratante">
                                        <div><strong>CONTRATANTE:</strong></div>
                                        <div><strong>N. Contrato:</strong><br />{{ user_status.contrato }}</div>
                                        <div><strong>Nombre:</strong><br />{{ user_status.contratante }}</div>
                                    </div>
                                </li>
                                <li class="col-12 col-sm-4">
                                    <div class="titular">
                                        <div><strong>TITULAR:</strong></div>
                                        <div v-if="user_status.tipo_afil == 9">
                                            <div><strong>Membresia:</strong><br />{{ user_status.infoTitular.sku_tit }}
                                            </div>
                                            <div><strong>Afiliado:</strong><br />{{ user_status.infoTitular.name_tit }}
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div><strong>Membresia:</strong><br />{{ user_status.sku }}</div>
                                            <div><strong>Afiliado:</strong><br />{{ user_status.afiliado }}</div>
                                        </div>
                                        <cite v-if="user_status.tipo_afil == 8">Quien recibe la atención médica</cite>
                                    </div>
                                </li>
                                <li class="col-12 col-sm-4">
                                    <div class="dependiente" v-if="user_status.tipo_afil == 9">
                                        <div><strong>DEPENDIENTE:</strong></div>
                                        <div><strong>Membresía:</strong><br />{{ user_status.sku }}</div>
                                        <div><strong>Afiliado:</strong><br />{{ user_status.afiliado }}</div>
                                        <cite>Quien recibe la atención médica</cite>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-sm-3 enableLabel">
                        <select v-model="sinester.reason_id" data-name-input="Motivo de la Atención" data-select="on"
                            class="required" id="">
                            <option :value="0">Motivo de la Atención</option>
                            <option v-for="reason in reasons" :key="reason.id" :value="reason.id">
                                {{ reason.name }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-sm-3 enableLabel">
                        <select v-model="sinester.place_id" data-name-input="Lugar de la Atención" data-select="on"
                            class="required" id="">
                            <option :value="0">Lugar de la Atención</option>
                            <option v-for="place in places" :key="place.id" :value="place.id">{{ place.name }}</option>
                        </select>
                    </div>
                    <div class="col-12 col-sm-3 enableLabel">
                        <div v-if="this.sinester.specialty_id === 25">
                            <h4 style="font-size:14px; text-align: right;"> Activar servicio de Papanicolau</h4>
                            <div style="margin:0 0 0 auto; width:70px;">
                                <input type="checkbox" v-model="sinester.papanicolau_serv" hidden="hidden"
                                    id="papanicolau">
                                <label class="switch" for="papanicolau"></label>
                            </div>
                        </div>

                        <div class="row" v-if="this.sinester.specialty_id === 43">
                            <div class="col-12 col-sm-6" v-if="this.honorariosReduccion != null">
                                <h4 style="font-size:14px; text-align: right;"> Reduccion</h4>
                                <div style="margin:0 0 0 auto; width:70px;">
                                    <input type="checkbox" v-model="sinester.is_reduccion" hidden="hidden"
                                        id="reduccion" @change="toggleCheckbox('reduccion')">
                                    <label class="switch" for="reduccion"></label>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6" v-if="this.honorariosPadecimiento != null">
                                <h4 style="font-size:14px; text-align: right;"> Padecimiento</h4>
                                <div style="margin:0 0 0 auto; width:70px;">
                                    <input type="checkbox" v-model="sinester.is_padecimiento" hidden="hidden"
                                        id="padecimiento" @change="toggleCheckbox('padecimiento')">
                                    <label class="switch" for="padecimiento"></label>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="this.sinester.specialty_id === 7 && this.honorariosElectro != null">
                            <div class="col-12 col-sm-12">
                                <h4 style="font-size:14px; text-align: right;"> Electrocardiograma en reposo</h4>
                                <div style="margin:0 0 0 auto; width:70px;">
                                    <input type="checkbox" v-model="sinester.is_electrocardiograma" hidden="hidden"
                                        id="electrocardiograma">
                                    <label class="switch" for="electrocardiograma"></label>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <!-- Diagnostico -->
                <div class="row mt-5">
                    <div class="col-12 col-sm-12">
                        <div class="alert alert-primary text-center" role="alert">
                            (Importante detallar) <strong>Cual es el diagnostico del Afiliado?</strong> Detallar un
                            informe médico del estado del paciente afiliado, <br />
                            (EN CASO DE ACCIDENTE MENCIONE: CUANDO, DONDE Y COMO OCURRIO? PARTICIPO ALGUNA AUTORIDAD?
                            HAY PERSONAS HOSPITALIZADAS Y QUE DAÑOS SUFRIERON
                        </div>
                        <div class="form-floating">
                            <editor v-model="sinester.diagnosis" plugins="lists advlist"
                                toolbar="bold italic | alignleft aligncenter alignright | bullist numlist | link image media | insertdatetime | code codesample" />
                        </div>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-12 col-sm-12">
                        <div class="alert alert-danger text-center" role="alert">
                            ESTUDIOS, EXAMENES Y SERVICIOS QUE PODRA SOLICITAR (POR PRESCRIPCIÓN DEL MÉDICO TRATANTE)
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-sm-12">
                        <div class="alert alert-light text-center" role="alert">
                            CUALQUIER EXAMEN, ESTUDIO O SERVICIO DIFERENTE A LOS AQUÍ SEÑALADOS, SERA PAGADO POR EL
                            SOLICITANTE CON LOS PORCENTAJES DE DESCUENTO CONVENIDOS CON EL PROVEEDOR
                        </div>
                    </div>
                </div>
                <!--SERVICIOS
                <div id="servicios" class="row mt-5">

                    <div v-if="show_col_inst" class="col-12" :class="'col-sm-'+spread_col">
                        <div class="alert alert-primary text-center" role="alert">
                            SERVICIO GENERAL
                        </div>
                        <ul id="listLab">
                            <li v-for="(inst) in instsServ" :key="inst.id" :value="inst.id">
                                <input class="float" type="checkbox" v-model="getServArrayInsts" :value="inst.id">
                                {{ inst.prueba }}
                            </li>
                        </ul>
                    </div>
                    <div v-if="show_col_dent" class="col-12" :class="'col-sm-'+spread_col">
                        <div class="alert alert-primary text-center" role="alert">
                            SERVICIO DENTALES
                        </div>
                        <ul>
                            <li v-for="(dent) in dentsServ" :key="dent.id">
                                <input class="float" type="checkbox" v-model="getServArrayInsts" :value="dent.id">
                                {{ dent.prueba }}
                            </li>
                        </ul>
                    </div>
                    <div v-if="show_col_opt" class="col-12" :class="'col-sm-'+spread_col">
                        <div class="alert alert-primary text-center" role="alert">
                            SERVICIO PAQUETE VISIÓN
                        </div>
                        <ul>
                            <li v-for="(opt) in optsServ" :key="opt.id">
                                <input class="float" type="checkbox" v-model="getServArrayInsts" :value="opt.id">
                                <label :for="opt.id">{{ opt.prueba }}</label>
                            </li>
                        </ul>
                    </div>
                    <div v-if="show_col_spe" class="col-12" :class="'col-sm-'+spread_col">
                        <div class="alert alert-primary text-center" role="alert">
                            SERVICIOS ESPECIALISTA
                        </div>
                        <ul class="row">
                            <li class="col-12  col-sm-12" v-for="(spec) in specServ" :key="spec.id">
                                <input class="float" type="checkbox" v-model="getServArraySpec" :value="spec.id">
                                {{ spec.prueba }}
                            </li>
                        </ul>
                    </div>

                </div>-->
                <!--FIRMA-->
                <div class="row">
                    <div class="col-12 col-sm-12">
                        <VueSignaturePad class="signature-pad" @save-image="handleImage" @touchmove.prevent />
                    </div>
                </div>

            </div>
        </form>
    </div>
</template>
<script>
import Vue from 'vue';
import { attendedbyService } from "../../Services/AttendedBy.service";
import { placeofcaresService } from "../../Services/PlaceOfCare.service";
import { reasonForAttentionsService } from "../../Services/ReasonForAttention.service";
import { supplierspecialistService } from "../../Services/SupplierSpecialist.service";
import { sinisterService } from "../../Services/Sinister.service";
import Editor from '@tinymce/tinymce-vue';
import { myMixins } from "../mixins/myMixins";
import VueSignaturePad from '../widgets/SignaturePad.vue';

import { membersService } from "../../Services/Members.service";
//import DatePicker from "vue2-datepicker";

export default {
    name: "control-consulta",
    mixins: [myMixins],
    components: {
        'editor': Editor,
        VueSignaturePad,
        DatePicker: () => import('vue2-datepicker'),
    },
    props: {
        updateRegister: {
            type: Object,
            required: false
        },
        kind_user: {
            type: String,
            required: true,
            default: ''
        },
        role_id: {
            type: Number,
            required: false,
            default: 0 // Aquí puedes establecer el valor por defecto
        },
        supplier_id: {
            type: Number,
            required: false,
            default: 0 // Aquí puedes establecer el valor por defecto
        },
        rel_specialist_specialties: {
            type: Array,
            required: false
        },
        rel_specialist_services: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            savedImage: null,
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                ["clean"]
            ],
            modificar: false,
            selectSpecCont: false,
            show_col_inst: false,
            show_col_opt: false,
            show_col_dent: false,
            show_col_amb: false,
            show_col_lab: false,
            show_col_rad: false,
            show_col_spe: false,
            spread_col: 0,
            user_status: {},
            specialties: [],
            sinester: {
                role_id: 0,
                supplier_id: 0,
                reason_id: 0,
                place_id: 0,
                specialty_id: null,
                type_service: 0,
                sku: '',
                kind_sku: '',
                diagnosis: '',
                rel_ser_sinester: [],
                fecha_atencion: '',
                paid_at: false,
                model_type: '',
                papanicolau_serv: false,
                is_session: 0,
                is_consultation: 0,
                is_reduccion: 0,
                is_padecimiento: 0,
                is_electrocardiograma: 0,
                total_de_consultas: 0,
                limit_eventos: 0,
            },
            honorariosSesiones: 0,
            honorariosReduccion: 0,
            honorariosPadecimiento: 0,
            honorariosElectro: 0,
            attended: [],
            places: [],
            reasons: [],
            ambsServ: [],
            labsServ: [],
            radsServ: [],
            dentsServ: [],
            optsServ: [],
            instsServ: [],
            specServ: [],
            getServArrayAmbs: [],
            getServArrayLabs: [],
            getServArrayRads: [],
            getServArrayDents: [],
            getServArrayOpts: [],
            getServArrayInsts: [],
            getServArraySpec: [],
            spec: [],
            type_serv_array: [],
        }
    },
    methods: {
        setEmpty() {
            this.sinester = {
                role_id: 0,
                supplier_id: 0,
                reason_id: 0,
                place_id: 0,
                specialty_id: null,
                type_service: 0,
                sku: '',
                kind_sku: '',
                diagnosis: '',
                rel_ser_sinester: [],
                fecha_atencion: '',
                paid_at: false,
                model_type: '',
                papanicolau_serv: false,
            }
        },
        async guardar() {
            let res = '';
            let respVal = this.valFormulariosV3('formSinester');

            if (respVal) {
                switch (this.sinester.role_id) {
                    case 3:
                        this.sinester.rel_ser_sinester = this.getServArrayAmbs;
                        break;
                    case 4:
                        if (this.spec.institution_id === null) {
                            this.sinester.rel_ser_sinester = this.getServArraySpec;
                        } else {
                            this.sinester.rel_ser_sinester = { ...this.getServArrayInsts, ...this.getServArrayLabs, ...this.getServArrayRads };
                        }
                        break;
                    case 7:
                        this.sinester.rel_ser_sinester = this.getServArrayInsts;
                        break;
                    case 10:
                        this.sinester.rel_ser_sinester = this.getServArrayLabs;
                        break;
                    case 11:
                        this.sinester.rel_ser_sinester = this.getServArrayDents;
                        break;
                    case 12:
                        this.sinester.rel_ser_sinester = this.getServArrayRads;
                        break;
                    case 13:
                        this.sinester.rel_ser_sinester = this.getServArrayOpts;
                        break;
                }

                this.sinester.sku = this.user_status.sku;
                this.sinester.kind_sku = this.user_status.tipo_afil;

                if (this.modificar) {
                    //console.log('actualizando el siniestro', this.sinester);
                    res = await sinisterService.updateOne(this.sinester.id, this.sinester);
                } else {
                    res = await sinisterService.saveOne(this.sinester);
                }
                //console.log('this.sinester', this.sinester);
                //console.log('res',res);
                this.setEmpty();
                this.getAlert(res.process, true);
                //window.location.reload();
            }

        },
        async index() {
            this.attended = await attendedbyService.getMany({});
            this.places = await placeofcaresService.getMany({});
            this.reasons = await reasonForAttentionsService.getMany({});
            // this.instsServ = await testlabhospService.getMany(this.selectInst);
            // this.labsServ = await testlabhospService.getMany(this.selectLabs);
            // this.ambsServ = await testlabhospService.getMany(this.selectAmbs);
            // this.dentsServ = await testlabhospService.getMany(this.selectDents);
            // this.optsServ = await testlabhospService.getMany(this.selectOpts);
            // this.radsServ = await testlabhospService.getMany(this.selectRad);
            // this.specServ = await testlabhospService.getMany(this.selectSpec);
            //await this.selectProvider();
            if (this.updateRegister && Object.keys(this.updateRegister).length > 0) {
                //console.log('updateRegister', this.updateRegister);
                await this.updateReg();
            } else {
                //console.log('no hay registro para actualizar');
            }
        },
        async showServicesByRole(role_id) {
            //console.log('mostrando los servicios segun el role', role_id);
            //MUESTRA LOS SERVICIOS SEGUN EL ROLE DEL USUARIO
            switch (Number(role_id)) {
                case 3:
                    this.show_col_amb = true;
                    this.spread_col = 12;
                    break;
                case 4:
                    console.log('medico especialista');
                    //necesito saber si el especialista que se esta logueando tiene una institucion asignada
                    this.spec = await supplierspecialistService.getOne(this.supplier_id);
                    this.show_col_spe = true;
                    this.show_col_inst = true;
                    this.show_col_rad = true;
                    this.show_col_lab = true;
                    this.spread_col = 3;
                    break;
                case 10:
                    this.show_col_lab = true;
                    this.spread_col = 12;
                    break;
                case 13:
                    this.show_col_opt = true;
                    this.spread_col = 12;
                    break;
                case 7:
                    this.show_col_inst = true;
                    this.show_col_rad = true;
                    this.show_col_lab = true;
                    this.spread_col = 4;
                    break;
            }
        },
        async selectEmployees($e) {
            let id = this.stateId($e);

            if (typeof $e === 'object') {
                this.sinester.supplier_id = $e.target.value;
                await this.showServicesByRole(this.sinester.role_id);
            }

        },
        toggleCheckbox(type) {
            if (type === 'reduccion' && this.sinester.is_reduccion) {
                this.sinester.is_padecimiento = false;
            } else if (type === 'padecimiento' && this.sinester.is_padecimiento) {
                this.sinester.is_reduccion = false;
            }
        },
        async updateReg() {
            //console.log('actualizando updateRegister',  this.updateRegister);

            this.modificar = true;
            this.sinester = this.updateRegister;
            this.sinester.paid_at = this.updateRegister.paid_at === 1;
            //console.log('this.sinester', this.sinester);
            if (this.sinester.attended_id === 2) {
                //console.log('especialista', this.sinester.supplier_id);
                let specialist_info = await supplierspecialistService.getOne(this.sinester.supplier_id);
                //recorrer el array que se encuentra dentro de la relacion  relspecialistservices para poder extraer lose servico asigandos

                this.type_serv_array = specialist_info.relspecialistservices.map((item) => {
                    return { id: item.service.id, serv: item.service.servicio };
                });

                //console.log('type_serv_array', this.type_serv_array);

                this.selectSpecCont = true;
                //await this.checkSpecialist(this.sinester.attended_id);
                await this.selectEmployees(this.sinester.role_id);
                await this.showServicesByRole(this.sinester.role_id);
            }

            this.user_status = await membersService.getMembers(this.sinester.sku);
        },
        userStatusUpdate(event) {
            //console.log('event = ', event);
            this.user_status = event;
            this.honorariosSesiones = this.user_status.honorariosSesiones;
            this.honorariosReduccion = this.user_status.honorariosReduccion;
            this.honorariosPadecimiento = this.user_status.honorariosPadecimiento;
            this.honorariosElectro = this.user_status.honorariosElectro;
            this.sinester.specialty_id = this.user_status.specialty_id;
            this.sinester.type_service = this.user_status.type_serv;
            this.sinester.total_de_consultas = this.user_status.previous_services_count;
            this.sinester.limit_eventos = this.user_status.limit_eventos;

            //console.log(this.user_status.specialty_id,' - this.user_status.previous_services_count ', this.user_status.previous_services_count);
            //el total que lleva el cliente servira para saber si son sesiones o consultas del rehabilitador
            if (this.user_status.specialty_id === 32) {
                //es que la especialidad es medico rehabilitador
                //console.log('es medico rehabilitador');
                if (this.user_status.previous_services_count === 0) {
                    this.sinester.is_consultation = 1;
                } else {
                    this.sinester.is_session = 1;
                }
            } else {
                this.sinester.is_consultation = 1;
            }

            //LAS VARIABLES PROV_ID Y PROV_ROLE_ID SON VARIABLES QUE NO SE REGRESAN CUANDO EL CONTROL DE CONSULTA ES USADO POR EL ESPECIALISTA
            //POR LO QUE SE DEBE DE VALIDAR QUE EXISTAN PARA PODER ASIGNARLAS A LA VARIABLE SINESTER
            //PERO SI NO EXISTEN SE DEBE DE ASIGNAR EL VALOR QUE SE RECIBE POR PROPS
            if (this.user_status.prov_id) {
                this.sinester.supplier_id = this.user_status.prov_id;
            } else {
                this.sinester.supplier_id = this.supplier_id;
            }

            if (this.user_status.prov_role_id) {
                this.sinester.role_id = this.user_status.prov_role_id;
                this.sinester.model_type = this.roleModels[this.user_status.prov_role_id];
            } else {
                this.user_status.prov_role_id = this.role_id;
                this.sinester.model_type = this.roleModels[this.role_id];
            }

            this.sinester.fecha_atencion = this.user_status.fecha_atencion;

            //console.log('objeto sinister=', this.sinester); // Aquí se imprime la variable en la consola
        },
        handleImage(imageBase64) {
            this.sinester.image = imageBase64;
            this.guardar()
        },

    },
    mounted() {
        this.index();
        //console.log(this.role_id, 'el role id')
    }
}
</script>

<style scoped>
#control-consulta-component #mainContent {
    margin: 20px 0;
}
</style>
